import type { MissSequencePhase } from 'react-chess-core';

/** Hide the move-quality dot while refutation feedback overlays the board. */
export function shouldSuppressMoveQualityDot(
  phase: MissSequencePhase | undefined,
): boolean {
  return phase === 'wrong' || phase === 'refutation' || phase === 'answer';
}
